module.exports = __webpack_public_path__ + "img/icon-white-40.a8f9ff97.svg";